import { Form, InputItem, TextareaItem, Button } from 'dingtalk-design-mobile'
import './PsychiatristForm.less'
import useHistory from '@/hooks/useHistory'
import { useState } from 'react'
import { _submitPsychological } from '@/api/user'


const PsychiatristForm = () => {
  
  const history = useHistory()

  const [formValue, setFormValue] = useState({
    name: '',
    mobile: '',
    address: '',
    content: '',
  })

  const onFinish = (val) => {
    _submitPsychological(val).then(res => {
      const [d, result] = res
      if (d && result) {
        history.push('/PsychiatristSuccess', 'route')
      }
    })
  }

  const validateMobile =  (_rule, value) => {
    const PhoneReg = /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-7|9])|(?:5[0-3|5-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[1|8|9]))\d{8}$/
    if (!value) {
      return Promise.reject(new Error('请输入手机号!'))
    }
    return PhoneReg.test(value) ? Promise.resolve() : Promise.reject(new Error('请输入正确的手机号!'))
  }

  return (
    <div className="pg-psychiatrist-form">
      <Form
        name="form" 
        initialValues={formValue} 
        className='form'
        onFinish={onFinish}
      >
        <div className='form-card pg-textarea '>
          <Form.Item label="咨询内容" name='content' layout="vertical" rules={[{ required: true, message: '请填写咨询内容' }]} >
            <TextareaItem rows={6} placeholder='请描述您要咨询的内容…' count={300} />
          </Form.Item>
        </div>
        <div className='form-card'>
          <Form.Item label="咨询人" name='name' rules={[{ required: true, message: '请填写咨询人姓名' }]}>
            <InputItem placeholder="请输入" maxLength={10} />
          </Form.Item>
          <Form.Item label="联系电话" name='mobile' rules={[{ required: true, validator: validateMobile }]}>
            <InputItem placeholder="请输入" inputMode='tel' />
          </Form.Item>
          <Form.Item label="联系地址" name='address' layout="vertical" >
            <TextareaItem rows={4} placeholder='请输入联系地址' count={50}  />
          </Form.Item>
          <Button className='btn' htmlType="submit">提交</Button>
        </div>
      </Form>
    </div>
  )
}

export default PsychiatristForm